import React from 'react'

import { Box, Card, ColorScheme, Flex, Text } from '@hivewatch/dark'

interface DarkEditDeviceSectionIProps {
  title: string
  description?: string
  actions?: React.ReactNode
  children: React.ReactNode
  colorScheme: ColorScheme
}

export const DarkEditDeviceSection = ({
  title,
  description,
  actions,
  children,
  colorScheme,
}: DarkEditDeviceSectionIProps) => {
  const secondaryText =
    colorScheme === 'light' ? 'light.text.secondary' : 'text.secondary'
  const cardBackground = colorScheme === 'light' ? 'light.bg.card' : 'bg.card'
  const cardBorder =
    colorScheme === 'light' ? 'light.border.subtle' : 'border.subtle'

  return (
    <Card
      bg={cardBackground}
      borderColor={cardBorder}
      boxShadow='none'
      colorScheme={colorScheme}
      p='20px'
    >
      <Flex
        align={{ base: 'stretch', md: 'flex-start' }}
        direction={{ base: 'column', md: 'row' }}
        gap='16px'
        justify='space-between'
      >
        <Box>
          <Text fontSize='16px' fontWeight='600' lineHeight='24px'>
            {title}
          </Text>
          {description && (
            <Text
              color={secondaryText}
              fontSize='12px'
              lineHeight='18px'
              mt='4px'
            >
              {description}
            </Text>
          )}
        </Box>
        {actions && (
          <Flex flexShrink={0} gap='8px'>
            {actions}
          </Flex>
        )}
      </Flex>
      <Box mt='20px'>{children}</Box>
    </Card>
  )
}
